import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import responseHandler from "../api/responseHandler";
import { environment } from "../environments/environment";
import { RootState } from "../store/store";

const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: environment.api.host,
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as RootState).auth.token;
            if (token) { // TODO: && environment.localApiAuth.apiUrls.some(url => args.url?.startsWith(url))
                headers.set("Authorization", `Bearer ${token}`);
                headers.set("palBranchId", "1"); // TODO: Add proper palBranchId value
                headers.set("palLng", localStorage.getItem('lang') ?? "de")
            }
            return headers;
        },
        responseHandler
    }),
    endpoints: () => ({}),
    reducerPath: "api",
    tagTypes: ["Policy", "Claim", "User"]
});

export default api;
